import { render, staticRenderFns } from "./addInviteItem.vue?vue&type=template&id=62d09ec4&scoped=true&"
import script from "./addInviteItem.vue?vue&type=script&lang=js&"
export * from "./addInviteItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62d09ec4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\admin\\datacenter_web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('62d09ec4')) {
      api.createRecord('62d09ec4', component.options)
    } else {
      api.reload('62d09ec4', component.options)
    }
    module.hot.accept("./addInviteItem.vue?vue&type=template&id=62d09ec4&scoped=true&", function () {
      api.rerender('62d09ec4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/gmToolNew/communication/components/addInviteItem.vue"
export default component.exports